export var OrderType;
(function (OrderType) {
    OrderType[OrderType["SALES_ORDER"] = 1] = "SALES_ORDER";
    OrderType[OrderType["PURCHASE_ORDER"] = 2] = "PURCHASE_ORDER";
    OrderType[OrderType["MANUFACTURING_ORDER"] = 3] = "MANUFACTURING_ORDER";
    OrderType[OrderType["TRANSFER_ORDER"] = 4] = "TRANSFER_ORDER";
    OrderType[OrderType["RMA"] = 5] = "RMA";
})(OrderType || (OrderType = {}));
//# sourceMappingURL=order-type.js.map